export function strlFacetwpTogglesToButtons() {
	const facetwpToggles = document.querySelectorAll('.facetwp-toggle');

	facetwpToggles.forEach((toggle, index) => {
		const ariaLabel = toggle.getAttribute('aria-label');
		const toggleText = toggle.innerHTML;
		const button = document.createElement('button');
		const classes = toggle.classList;
		button.innerHTML = toggleText;
		button.setAttribute( 'role', 'link' );
		button.setAttribute( 'aria-label', ariaLabel );
		button.setAttribute( 'tabindex', '0' );

		classes.forEach((cls) => {
			button.classList.add( cls );
		});

		toggle.parentElement.appendChild( button );
		toggle.remove();
	});
}

export function strlFacetwpCheckboxDepthToggles() {
	const checkboxes = document.querySelectorAll('.facetwp-checkbox');
	checkboxes.forEach((checkbox) => {
		// Only wrap items with children
		const nextSibling = checkbox.nextSibling;
		if ( nextSibling ) {
			if ( ! nextSibling.classList.contains('facetwp-depth') ) {
				return;
			}
		} else {
			return;
		}


		const html = checkbox.outerHTML;
		checkbox.outerHTML = '<span class="flex-wrapper flex items-baseline justify-between">' + html + '<button class="custom-depth-toggle" data-more="[+]" data-less="[-]">[+]</button></span>';
	});

	const toggles = document.querySelectorAll('.custom-depth-toggle');
	toggles.forEach((toggle) => {
		toggle.addEventListener('click', function (e) {
			toggle.closest( '.flex-wrapper' ).nextSibling.classList.toggle( 'visible' )
			toggle.classList.toggle( 'active' );

			if ( toggle.classList.contains( 'active' ) ) {
				toggle.textContent = toggle.getAttribute('data-less');
			} else {
				toggle.textContent = toggle.getAttribute('data-more');
			}
		});
	});
}

export function strlSetSelectionValuesAriaLabels() {
	const elements = document.querySelectorAll('.facetwp-selection-value');

	elements.forEach(function(element) {
		const title = element.getAttribute('data-value');
		element.setAttribute('aria-label', title + ' ' + strl_vars.translate_remove_label);
	});
}

export function strlFacetwpFselectKeyboard(multiSelect = false) {
	const fSelects = document.querySelectorAll('.facetwp-type-fselect');

	fSelects.forEach((item) => {
		item.addEventListener('keydown', (e) => {
			let key = e.key;
			const filterName = item.dataset.name;

			if ('Enter' === key && filterName) {
				e.preventDefault();
				const filterValue = e.target.dataset.value;
				if (filterValue) {
					if (!multiSelect) {
						FWP.facets[filterName] = []; // empty array, remove this if multi select is
					}

					FWP.facets[filterName].push(filterValue);

					FWP.fetchData();
					FWP.setHash();
				}
			}
		});
	});
}

export function strlFacetwpCheckboxAriaLabels() {
	const checkboxes = document.querySelectorAll('.facetwp-checkbox');
	checkboxes.forEach((checkbox) => {
		const displayValue = checkbox.querySelector('.facetwp-display-value');
		checkbox.ariaLabel = displayValue.innerText;
	});
}